import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const ClearCircle: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clear-circle-clip)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58173 16 0 12.4183 0 8C0 3.58173 3.58173 0 8 0C12.4183 0 16 3.58173 16 8ZM4.53677 4.53677C4.8715 4.20203 5.41422 4.20203 5.74895 4.53677L8 6.78782L10.2511 4.53677C10.5858 4.20203 11.1285 4.20203 11.4632 4.53677C11.7979 4.8715 11.7979 5.41422 11.4632 5.74895L9.21218 8L11.4632 10.2511C11.7979 10.5858 11.7979 11.1285 11.4632 11.4632C11.1285 11.7979 10.5858 11.7979 10.2511 11.4632L8 9.21218L5.74895 11.4632C5.41422 11.7979 4.8715 11.7979 4.53677 11.4632C4.20203 11.1285 4.20203 10.5858 4.53677 10.2511L6.78782 8L4.53677 5.74895C4.20203 5.41422 4.20203 4.8715 4.53677 4.53677Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clear-circle-clip">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
